export default {
    down: {
        title: 'Trouble connecting to athlisis',
        text: "We're reconnecting automatically. Until then, your changes won't be saved.",
    },
    restored: {
        title: 'Connection restored',
        text: "If something didn't load properly, refresh the page.",
    },
}
